module.exports = __webpack_public_path__ + "img/ggpay.c8aec9d5.svg";